interface PublicSectionTitleProps {
  title: string;
  description?: string;
  light?: boolean;
}

const PublicSectionTitle = ({
  title,
  description,
  light = false,
}: PublicSectionTitleProps) => (
  <div
    className={`psite-section__title ${light ? "psite-section__title--light" : ""}`}
  >
    <h2>{title}</h2>
    {description && <p>{description}</p>}
  </div>
);

export default PublicSectionTitle;